import apiV2 from "api-v2";

import type { ExecutiveCompanyOption } from "../types/ExecutiveCompanyOption.type";

export const switchCompany = (companyId: number) =>
	apiV2.post(`/executive/switch-company/${companyId}`);

export const switchBack = () => apiV2.post("/executive/switch-back");

export const searchCompanies = (search: string, limit = 25) =>
	apiV2.get<{ data: ExecutiveCompanyOption[] }>("/executive/companies", {
		params: { search, limit },
	});
